var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rich-text',{attrs:{"value":_vm.value,"placeholders":_vm.placeholders,"readonly":_vm.readonly,"allowImages":_vm.allowImages},on:{"input":function (v) { return _vm.$emit('input', v); }}})}
var staticRenderFns = []

export { render, staticRenderFns }